<div class="flex items-start">
	<button class="p-2 text-gray-900 cursor-pointer" (click)="previousWeek()">
		<lucide-icon [img]="ChevronLeftIcon" [size]="16"></lucide-icon>
	</button>
	<div class="w-full flex flex-col">
		<div class="grid grid-cols-6">
			@for (day of nextSixDays; track day.id) {
			<div class="flex flex-col items-center text-gray-800">
				<p class="text-[12px]">{{day.dayName}}</p>
				<p class="text-[10px] opacity-70">{{day.day}} {{day.month}}</p>
			</div>
			}
		</div>
		<div class="flex-grow grid grid-cols-6 gap-1 mt-2">
			@for (day of nextSixDays; track day.id) {
			<div class="overflow-y-auto flex flex-col gap-y-2 max-h-48">
				@for (slot of day.slots; track slot.startDateFull) {
				<button
					class="bg-gray-200 text-gray-500 rounded-lg text-[13px] font-medium p-1 hover:bg-primary hover:text-white transition-colors cursor-pointer"
					(click)="onSlotClick(slot)">
					{{slot.startDateFull.split(' ')[1]}} 
				</button>
				}
			</div>
			}
		</div>
		@if (emptySlots && !loading) {
		<div class="flex-grow flex items-center justify-center min-h-48">
			<div class="bg-primary text-white rounded-lg text-[12px] flex items-center gap-x-2 font-medium p-1">
				<lucide-icon [img]="AlertCircleIcon" [size]="16"></lucide-icon>
				Pas de créneaux disponibles pour cette semaine.
			</div>
		</div>
		}
		@if (loading) {
		<div class="flex-grow flex items-center justify-center min-h-48">
			<div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
		</div>
		}
	</div>
	<button class="p-2 text-gray-900 cursor-pointer" (click)="nextWeek()">
		<lucide-icon [img]="ChevronRightIcon" [size]="16"></lucide-icon>
	</button>
</div>
		